import { render, staticRenderFns } from "./comNumberBox.vue?vue&type=template&id=04a2e5e0&"
import script from "./comNumberBox.vue?vue&type=script&lang=js&"
export * from "./comNumberBox.vue?vue&type=script&lang=js&"
import style0 from "./comNumberBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports